import { commonChecks } from '@xhs/ozone-detector'

import { appVersionGte, appVersionLt } from './version'

import BridgeError from '../utils/BridgeError'

export default function bridge(method, options, funcName) {
  const postData = {}

  if (options !== undefined) {
    postData.data = options
  }

  if (funcName) {
    postData.callback = funcName
  }

  if (commonChecks.isIOS) {
    // FIXME: 兼容 iOS 5.29、5.30 从 postData.data 取回调函数 key，而不是 postData.callback
    if (
      method === 'registerNotice'
      && appVersionGte('5.29')
      && appVersionLt('5.31')
    ) {
      try {
        window.webkit.messageHandlers[method].postMessage({
          data: funcName,
        })
      } catch (e) {
        throw new BridgeError('ERR_NATIVE', e.message)
      }
      return
    }

    try {
      window.webkit.messageHandlers[method].postMessage(postData)
    } catch (e) {
      throw new BridgeError('ERR_NATIVE', `${e.message}, bridge is ${method}`)
    }
  } else {
    const postDataStr = JSON.stringify(postData)

    try {
      window.xhsbridge[method](postDataStr)
    } catch (e) {
      throw new BridgeError('ERR_NATIVE', `${e.message}, bridge is ${method}`)
    }
  }
}
